namespace appn.views.dataSources.index {

    class InitArgs {
        types: Array<SelectListItem> = [];
        dataSourcesCreate: string = emptyString;
        dataSourcesIndex: string = emptyString;
    }

    let _initArgs: InitArgs; 
    let _dataTable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;

        createDataTable();
    }

    function createDataTable() {
        appn.folderFilter.init(_initArgs.dataSourcesIndex);
        _dataTable = appn.dataTable.create('.dataTable', {
            sAjaxSource: 'DataSources/DataTable',
            fnServerData: function(data: any) {
                data.push({ name: 'sCustom_0', value: appn.folderFilter.getStateOrDefault().value },
                    appn.dataTable.getStateOrDefault('sCustom_1', $('#sCustom_1').val()));
            },
            aaSorting: [[1, 'asc']],
            autoWidth: false,
            aoColumns: [
                { bSortable: false, sWidth: '3%' },
                { bSortable: true, sWidth: '50%' },
                { bSortable: true, sWidth: '12%' },
                { bSortable: true, sWidth: '17%' },
                { bSortable: true, sWidth: '17%' }
            ],
            fnInitComplete: function(): any {
                let navbarActionButtons = [
                    { buttonId: 'organiseBtn', buttonType: 'Organise', isDataTableToggleBtn: true },
                    { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                ];
                                
                // Inject Screen Action buttons
                appn.actionButtons.renderNavbarActionButtons(navbarActionButtons, appn.requestUser.isUserOrHigher, true);

                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'addnew', buttonType: 'AddNew' }
                ], appn.requestUser.isUserOrHigher);

                $('#addnew').click(function(e): void {
                    e.preventDefault();
                    appn.location.navTo(_initArgs.dataSourcesCreate, [{ name: 'folderId', value: appn.folderFilter.selectedFolderId }]);
                });

                // Prpend the show button
                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));

                // Bind organise button
                $('#organiseBtn').click(function(e): void {
                    e.preventDefault();
                    appn.folderFilter.showDialog($(this));
                });

                $('#manageBtn').click(function(e): void {
                    e.preventDefault();

                    // Find checked checkboxes with the 'selectRow' class within the datatable
                    const selectedRows = $('.dataTable').find('.selectRow:checked');

                    if (selectedRows.length > 0) {
                        let ids = '';
                        $(selectedRows).map(function() {
                            ids += ($(this).attr('id')) + ',';
                        });

                        $('#dataSourcesToManage').val(ids);
                        $('#manageDataSourcesDialog').modal('show');

                        const submitButton = $('#manageDataSourcesDialog .card-header button[value="Manage_Trash"].btn-tool-danger');
                        appn.trash.createTrashMessageFromTable(submitButton, selectedRows, T('Data Sources'));
                    }
                });

                $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.types, 'sCustom_1', 'form-control-sm form-control saveMeState', T('ALL TYPES')));

                appn.dataTable.addSearchPlaceholder(T(`Filter results where this Data Source's <b>Rows or Columns</b> contain a keyword typed in here.`));

                appn.saveMeState.init(function(): any {
                        _dataTable.fnDraw(false);
                    },
                    function(): any {
                        _dataTable.fnDraw(false);
                    },
                    '.dataTables_filter');
            }
        });
    }
}
